module.exports = __webpack_public_path__ + "6ec90ad099ea0019b78fe009adc358b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/bp.svg
// module id = 411
// module chunks = 0